import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function PatientFiSection() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px] overflow-hidden" data-id="element-1269">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1270">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1271">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" data-id="element-1272">
            <div className="relative mx-auto max-w-[400px] lg:max-w-none bg-white rounded-2xl p-12 aspect-square flex items-center justify-center shadow-xl" data-id="element-1273">
              <h3 className="text-4xl font-bold text-black relative z-10 font-[Poppins,_sans-serif] tracking-wider" data-id="element-1274">
                PatientFi
              </h3>
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" delay={200} data-id="element-1275">
            <span className="text-[#FF1493] uppercase text-[13px] font-bold tracking-[2px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1276">
              FINANCING PARTNER
            </span>

            <h2 className="text-[28px] sm:text-4xl lg:text-[44px] uppercase text-black leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-1277">
              HOW PATIENTFI WORKS
            </h2>

            <p className="text-[#FF1493] text-xl font-serif italic mb-8" data-id="element-1278">
              Goodbye Outdated Financing, Hello Friendly Monthly Payment Plans
            </p>

            <div className="bg-white border-l-4 border-[#FF1493] p-5 mb-10 rounded-r shadow-sm" data-id="element-1279">
              <p className="text-black text-[15px] italic font-serif" data-id="element-1280">
                "For example, a $500 purchase may cost $20/month for 24 months
                at 0% APR with $25 due at the time of purchase."
              </p>
            </div>

            <div className="space-y-8 mb-10" data-id="element-1281">
              <div data-id="element-1282">
                <h3 className="text-black font-bold text-lg mb-2 font-[Poppins,_sans-serif]" data-id="element-1283">
                  No Risk (and no worries) To See Your Offer
                </h3>
                <p className="text-[#333333] text-[15px] font-body leading-[1.7]" data-id="element-1284">
                  Want to see what your monthly plan would look like with
                  PatientFi before you commit? No problem. You can easily see
                  what you qualify for before you decide to move forward.
                </p>
              </div>

              <div data-id="element-1285">
                <h3 className="text-black font-bold text-lg mb-2 font-[Poppins,_sans-serif]" data-id="element-1286">
                  We Have Your Best Interest At Heart
                </h3>
                <p className="text-[#333333] text-[15px] font-body leading-[1.7]" data-id="element-1287">
                  How does 0% APR financing sound? And with a friendly monthly
                  payment plan, you can have what you want today and pay for it
                  over time. No hidden fees or gotchas. No compounding interest.
                  Just an affordable way to pay that works for you.
                </p>
              </div>

              <div data-id="element-1288">
                <h3 className="text-black font-bold text-lg mb-2 font-[Poppins,_sans-serif]" data-id="element-1289">
                  We Say Yes To More Patients
                </h3>
                <p className="text-[#333333] text-[15px] font-body leading-[1.7]" data-id="element-1290">
                  Unlike other financing options, we look beyond credit scores
                  to get a better picture of the whole (amazing) person you
                  are—so we can approve more patients, and offer higher amounts.
                </p>
              </div>
            </div>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-1291">
              SIGN UP WITH PATIENTFI
            </Button>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}